import { createActionName } from './naming';
import * as types from './actionsTypes';

export const sendForm = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SEND_FORM),
  payload
});

export const setFieldSum = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_SUM),
  payload
});

export const setFieldOutputAccountsType = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_OUTPUT_ACCOUNTS_TYPE),
  payload
});

export const setFieldAccountNumber = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_ACCOUNT_NUMBER),
  payload
});

export const setFieldBankKey = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_BANK_KEY),
  payload
});

export const setFieldMemoTag = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_FIELD_MEMO_TAG),
  payload
});

export const setCommission = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_COMMISSION),
  payload
});

export const setResultObject = (reducerName, payload) => ({
  type: createActionName(reducerName, types.SET_RESULT_OBJECT),
  payload
});

export const initState = reducerName => ({
  type: createActionName(reducerName, types.INIT_STATE)
});



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputCashFrom/actions.js